import { useValidate } from "formvalidation/hooks";
import React, { useRef } from "react";
import { saveOrCancel } from "utilities/inputUtils";
import { InputBase } from "./Atoms/formInputs/InputBase";

interface Props {
  value: string
  onValueChange: (newValue: string) => void
  validatorKey: string
  focusOnMount?: boolean
  onEnter?: () => void
  onEsc?: () => void
  maxLength: number
}

const UrlInput = (props: Props) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const verifyIsValid = async () => {
    if (props.value == null || props.value === "") {
      return true;
    }

    const result = await window.CoreApi.Url.Reformat(props.value)
    const isValid = !result.data.hasErrors;

    return isValid;
  };

  const validation = useValidate({
    key: props.validatorKey,
    title: "URL",
    value: props.value,
    validate: verifyIsValid,
    ref: inputRef,
    type: "manual"
  })

  return <InputBase
    ref={inputRef}
    onKeyDown={e => saveOrCancel(e, { onEnter: props.onEnter, onEsc: props.onEsc, validation, value: props.value })}
    error={validation.error.hasError}
    value={props.value}
    onChange={value => { props.onValueChange(value); }}
    onBlur={validation.validateAndSetError}
    maxLength={props.maxLength}
    focusOnMount={props.focusOnMount}
  />;
};

export default UrlInput;
